export enum Title {
    VITA_CONCIERGE = 'Vita Concierge',
    VITA_STUDENT_CONCIERGE = 'Vita Student - Concierge',
    HOUSE_OF_SOCIAL = 'House of Social',
    VITA_STUDENT = 'Vita Student',
}
